import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { AIOutlineButton } from '../ui/AIOutlineButton';
interface RedemptionsByTypeChartProps {
  data: {
    type: string;
    count: number;
    image?: string;
  }[];
  onAIClick?: () => void;
}
const RedemptionsByTypeChart: React.FC<RedemptionsByTypeChartProps> = ({
  data,
  onAIClick
}) => {
  // Color palette for different reward types
  const COLORS = ['#1a4d2e', '#2d7a4f', '#4aa770', '#7bc99c', '#a8ddb5', '#c7e9c0'];
  // Calculate total for percentages
  const total = data.reduce((sum, entry) => sum + entry.count, 0);
  // Custom label to show percentage
  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }: any) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent < 0.05) return null;
    return <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={12} fontWeight="600" data-id="element-339">
        {`${(percent * 100).toFixed(0)}%`}
      </text>;
  };
  // Custom tooltip
  const CustomTooltip = ({
    active,
    payload
  }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = (data.value / total * 100).toFixed(1);
      return <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-lg" data-id="element-340">
          <p className="font-semibold text-gray-900 mb-1" data-id="element-341">{data.name}</p>
          <p className="text-sm text-gray-600" data-id="element-342">
            Riscatti: <span className="font-medium" data-id="element-343">{data.value}</span>
          </p>
          <p className="text-sm text-gray-600" data-id="element-344">
            Percentuale: <span className="font-medium" data-id="element-345">{percentage}%</span>
          </p>
        </div>;
    }
    return null;
  };
  // Custom legend
  const renderLegend = (props: any) => {
    const {
      payload
    } = props;
    return <div className="flex flex-wrap justify-center gap-3 mt-4" data-id="element-346">
        {payload.map((entry: any, index: number) => <div key={`legend-${index}`} className="flex items-center gap-2" data-id="element-347">
            <div className="w-3 h-3 rounded-full" style={{
          backgroundColor: entry.color
        }} data-id="element-348" />
            <span className="text-xs text-gray-600" data-id="element-349">{entry.value}</span>
          </div>)}
      </div>;
  };
  return <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-350">
      <div className="flex items-center justify-between mb-4" data-id="element-351">
        <h3 className="text-lg font-semibold" data-id="element-352">Riscatti per Tipo Premio</h3>
        <AIOutlineButton onClick={onAIClick} title="AI Insights" data-id="element-353">
          Suggerimenti AI
        </AIOutlineButton>
      </div>
      <div className="h-80" data-id="element-354">
        <ResponsiveContainer width="100%" height="100%" data-id="element-355">
          <PieChart data-id="element-356">
            <Pie data={data} cx="50%" cy="50%" labelLine={false} label={renderCustomLabel} outerRadius={120} fill="#8884d8" dataKey="count" nameKey="type" data-id="element-357">
              {data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-358" />)}
            </Pie>
            <Tooltip content={<CustomTooltip data-id="element-360" />} data-id="element-359" />
            <Legend content={renderLegend} data-id="element-361" />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>;
};
export default RedemptionsByTypeChart;